module.exports = __webpack_public_path__ + "static/media/img4.32efb379.jpeg";